function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import AiOutlinePrinter from "@meronex/icons/ai/AiOutlinePrinter";
import GrClose from "@meronex/icons/gr/GrClose";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { LinkParagraph, copyCodeHandler } from "../../../utils/helpers";
import SideModal from "../../Common/SideModal";
import { toast } from "react-toastify";
import ReactGA from "react-ga4";
import PhoneNumber from "../Components/PhoneNumber";
import DealValidity from "../Components/DealDetails/Components/DealValidity";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
function BundleDetails(_ref) {
  var _location$state, _location$state2, _redux$auth$isAuthent, _redux$auth, _redux$webView$client, _redux$webView, _redux$webView$intern, _redux$webView2, _redux$auth$userDetai, _redux$auth2, _redux$userDetails;
  var _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    cmsClient = _ref.cmsClient,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    search: "",
    pathname: "",
    state: {}
  };
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    goBack: function goBack() {},
    replace: function replace() {}
  };
  var _useState = useState(((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.offers) || []),
    _useState2 = _slicedToArray(_useState, 2),
    dealDetails = _useState2[0],
    setDealDetails = _useState2[1];
  var otherBundleDeals = ((_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.filteredOffers) || [];
  var _useState3 = useState(otherBundleDeals.length > 0),
    _useState4 = _slicedToArray(_useState3, 2),
    showModal = _useState4[0],
    setShowModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    bundleLoading = _useState6[0],
    setBundleLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    bundleDealDetails = _useState8[0],
    setBundleDealDetails = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    captureUserMobile = _useState0[0],
    setCaptureUserMobile = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    previousSelectedOffers = _useState10[0],
    setPreviousSelectedOffers = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showTnc = _useState12[0],
    setShowTnc = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    copiedText = _useState14[0],
    setCopiedText = _useState14[1];
  // const [openBundleModal, setOpenBundleModal] = useState(otherBundleDeals.length > 0);
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedOffers = _useState16[0],
    setSelectedOffers = _useState16[1];
  var isAuthenticated = (_redux$auth$isAuthent = redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated) !== null && _redux$auth$isAuthent !== void 0 ? _redux$auth$isAuthent : redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var clientWebview = (_redux$webView$client = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.clientWebview) !== null && _redux$webView$client !== void 0 ? _redux$webView$client : redux === null || redux === void 0 ? void 0 : redux.clientWebview;
  var internalWebview = (_redux$webView$intern = redux === null || redux === void 0 || (_redux$webView2 = redux.webView) === null || _redux$webView2 === void 0 ? void 0 : _redux$webView2.internalWebview) !== null && _redux$webView$intern !== void 0 ? _redux$webView$intern : redux === null || redux === void 0 ? void 0 : redux.internalWebview;
  var clickThroughMobile = clientWebview || internalWebview;
  var queryParams = new URLSearchParams(location.search);
  var channel = queryParams.get("utm_medium");
  var userMobile = (_redux$auth$userDetai = redux === null || redux === void 0 || (_redux$auth2 = redux.auth) === null || _redux$auth2 === void 0 || (_redux$auth2 = _redux$auth2.userDetails) === null || _redux$auth2 === void 0 ? void 0 : _redux$auth2.mobileNumber) !== null && _redux$auth$userDetai !== void 0 ? _redux$auth$userDetai : redux === null || redux === void 0 || (_redux$userDetails = redux.userDetails) === null || _redux$userDetails === void 0 ? void 0 : _redux$userDetails.mobileNumber;
  var onClick = function onClick() {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("Printclicked");
    window.print();
  };
  var handleCopyCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(deal) {
      var code;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            code = (deal === null || deal === void 0 ? void 0 : deal.redemptionType) == "VOUCHER" ? deal === null || deal === void 0 ? void 0 : deal.VoucherCode : deal === null || deal === void 0 ? void 0 : deal.dealRedemptionCode;
            _context.n = 1;
            return copyCodeHandler(code, setCopiedText);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleCopyCode(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    var _window2, _dealDetails$;
    // console.log(
    //     dealDetails,
    //     dealDetails[0]?.tags[0]?.name,
    //     dealDetails[0]?.tags[0],
    //     dealDetails?.map((deal) => deal?.id)
    // );
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("BundleDealRedeemed", {
      DealIds: "".concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.map(function (deal) {
        return deal === null || deal === void 0 ? void 0 : deal.id;
      })),
      BundleType: (_dealDetails$ = dealDetails[0]) === null || _dealDetails$ === void 0 || (_dealDetails$ = _dealDetails$.tags[0]) === null || _dealDetails$ === void 0 ? void 0 : _dealDetails$.name
    });
  }, []);
  if (dealDetails.length === 0) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: "/404"
    });
  }
  var handleCheckboxChange = function handleCheckboxChange(offer) {
    setSelectedOffers(function (prevSelected) {
      var isSelected = prevSelected === null || prevSelected === void 0 ? void 0 : prevSelected.some(function (item) {
        return item.id === offer.id;
      });
      if (isSelected) {
        return prevSelected === null || prevSelected === void 0 ? void 0 : prevSelected.filter(function (item) {
          return item.id !== offer.id;
        });
      } else {
        return [].concat(_toConsumableArray(prevSelected), [offer]);
      }
    });
  };
  var handleRedeemDeal = function handleRedeemDeal(mobile) {
    if (!isAuthenticated) {
      if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
        dispatch(authActions.openLoginModal());
      }
      return;
    }
    if (!userMobile && !mobile) {
      setCaptureUserMobile(true);
      setShowModal(true);
      setShowTnc(true);
      return;
    }
    setBundleLoading(true);
    var selectedOffersIds = selectedOffers.map(function (offer) {
      return offer.id;
    });
    console.log("selectedOffersIds", selectedOffersIds);
    var apiCall = Promise.all(selectedOffersIds === null || selectedOffersIds === void 0 ? void 0 : selectedOffersIds.map(function (id) {
      return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
        method: "GET",
        url: "/winnre/user/deals/".concat(id)
      });
    }));
    setBundleLoading(true);
    apiCall.then(function (res) {
      // setOpenBundleModal(false);
      setBundleDealDetails(res);
      setShowTnc(true);
      // setShowModal(true);
      setBundleLoading(false);
      setPreviousSelectedOffers(_toConsumableArray(selectedOffers));
      setSelectedOffers([]);
      previousSelectedOffers === null || previousSelectedOffers === void 0 || previousSelectedOffers.forEach(function (offer) {
        var _window3, _offer$tags;
        (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.webengage) === null || _window3 === void 0 || _window3.track("RedeemSelectedDealClicked", {
          DealId: "".concat(offer === null || offer === void 0 ? void 0 : offer.id),
          BrandName: "".concat(offer === null || offer === void 0 ? void 0 : offer.vendorName),
          Category: "".concat(offer === null || offer === void 0 ? void 0 : offer.categoryName),
          // Tags: `${offer?.Tags}`
          Tags: "".concat(offer === null || offer === void 0 || (_offer$tags = offer.tags) === null || _offer$tags === void 0 ? void 0 : _offer$tags.map(function (tag) {
            return tag === null || tag === void 0 ? void 0 : tag.name;
          }))
        });
      });
    })["catch"](function (err) {
      toast.error("Something Went Wrong");
      setBundleLoading(false);
    });
  };
  var redeemSelectedBundleOffers = function redeemSelectedBundleOffers() {
    if (cmsClient.defaults.baseURL === "https://prod.loyalie.in" || cmsClient.defaults.baseURL === "https://uat.loyalie.in") {
      window.fbq("trackCustom", "RedeemNowButtonClicked");
    }
    ReactGA.event({
      category: "OFFER",
      action: "REDEEM NOW CLICKED",
      label: "REDEEM OFFER BUTTON"
    });
    var dealsToMap = previousSelectedOffers;
    var processDeals = function processDeals(deals, res) {
      var index = 0;
      var offers = bundleDealDetails;
      var _iterator = _createForOfIteratorHelper(deals),
        _step;
      try {
        var _loop = function _loop() {
          var _window4, _deal$tags, _res$index, _res$index2, _res$index3, _res$index4, _res$index5, _res$index6, _res$index7, _res$index8, _res$index9, _res$index0, _res$index1, _res$index10, _res$index11, _res$index12, _res$index13, _res$index14, _res$index15, _res$index16;
          var deal = _step.value;
          (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.webengage) === null || _window4 === void 0 || _window4.track("DealClicked", _objectSpread(_objectSpread({
            OfferName: "".concat(deal === null || deal === void 0 ? void 0 : deal.title),
            RedemptionType: "".concat(deal === null || deal === void 0 ? void 0 : deal.redemptionType),
            CashbackPercentage: "".concat(deal === null || deal === void 0 ? void 0 : deal.eligibleCashback),
            CouponCode: "".concat(deal === null || deal === void 0 ? void 0 : deal.dealRedemptionCode),
            Category: "".concat(deal === null || deal === void 0 ? void 0 : deal.categoryName),
            Vendor: "".concat(deal === null || deal === void 0 ? void 0 : deal.vendorName),
            Link: "".concat(deal === null || deal === void 0 ? void 0 : deal.url),
            EndDate: "".concat(deal === null || deal === void 0 ? void 0 : deal.endDate),
            Tags: "".concat(deal === null || deal === void 0 || (_deal$tags = deal.tags) === null || _deal$tags === void 0 ? void 0 : _deal$tags.map(function (tag) {
              return tag === null || tag === void 0 ? void 0 : tag.name;
            })),
            DealId: "".concat(deal === null || deal === void 0 ? void 0 : deal.id),
            VoucherCode: deal.dealType === "OFFLINE" ? "" : (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === "VOUCHER" && ((_res$index = res[index]) === null || _res$index === void 0 ? void 0 : _res$index.status) === "SUCCESS" ? (_res$index2 = res[index]) === null || _res$index2 === void 0 ? void 0 : _res$index2.dealCode : ((_res$index3 = res[index]) === null || _res$index3 === void 0 ? void 0 : _res$index3.status) === "FAILED" && (_res$index4 = res[index]) !== null && _res$index4 !== void 0 && _res$index4.message.includes("Repeat:") ? (_res$index5 = res[index]) === null || _res$index5 === void 0 ? void 0 : _res$index5.message.split("Repeat:")[1] : ""
          }, deal.redemptionType === "VOUCHER" && deal.dealType === "OFFLINE" && {
            QRCode: ((_res$index6 = res[index]) === null || _res$index6 === void 0 ? void 0 : _res$index6.status) === "SUCCESS" ? (_res$index7 = res[index]) === null || _res$index7 === void 0 ? void 0 : _res$index7.dealQRCodeLink : ((_res$index8 = res[index]) === null || _res$index8 === void 0 ? void 0 : _res$index8.status) === "FAILED" ? (_res$index9 = res[index]) === null || _res$index9 === void 0 ? void 0 : _res$index9.message.split("Repeat:")[1] : ""
          }), {}, {
            Channel: channel ? channel : "Direct"
          }));
          var offersIndex = offers.findIndex(function (o) {
            return o.id === (deal === null || deal === void 0 ? void 0 : deal.id);
          });
          offers[offersIndex] = _objectSpread(_objectSpread(_objectSpread({}, offers[offersIndex]), deal), {}, {
            VoucherCode: deal.dealType === "OFFLINE" ? "" : (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === "VOUCHER" && ((_res$index0 = res[index]) === null || _res$index0 === void 0 ? void 0 : _res$index0.status) === "SUCCESS" ? (_res$index1 = res[index]) === null || _res$index1 === void 0 ? void 0 : _res$index1.dealCode : ((_res$index10 = res[index]) === null || _res$index10 === void 0 ? void 0 : _res$index10.status) === "FAILED" && (_res$index11 = res[index]) !== null && _res$index11 !== void 0 && _res$index11.message.includes("Repeat:") ? (_res$index12 = res[index]) === null || _res$index12 === void 0 ? void 0 : _res$index12.message.split("Repeat:")[1] : ""
          }, deal.redemptionType === "VOUCHER" && deal.dealType === "OFFLINE" && {
            QRCode: ((_res$index13 = res[index]) === null || _res$index13 === void 0 ? void 0 : _res$index13.status) === "SUCCESS" ? (_res$index14 = res[index]) === null || _res$index14 === void 0 ? void 0 : _res$index14.dealQRCodeLink : ((_res$index15 = res[index]) === null || _res$index15 === void 0 ? void 0 : _res$index15.status) === "FAILED" ? (_res$index16 = res[index]) === null || _res$index16 === void 0 ? void 0 : _res$index16.message.split("Repeat:")[1] : ""
          });
          index++;
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return offers;
    };
    setBundleLoading(true);
    Promise.all(dealsToMap === null || dealsToMap === void 0 ? void 0 : dealsToMap.map(function (deal) {
      return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
        method: "POST",
        url: "winnre/user/deals/redeem-v2?dealId=".concat(deal === null || deal === void 0 ? void 0 : deal.id, "&sourcePlatform=").concat(clickThroughMobile ? "MOBILE" : "WEBSITE").concat(channel ? "&channel=".concat(channel) : "")
      });
    })).then(function (res) {
      var _window5;
      var updatedOffers = processDeals(dealsToMap, res);
      setDealDetails(function (prevDetails) {
        return [].concat(_toConsumableArray(prevDetails), _toConsumableArray(updatedOffers));
      });
      // history.push({
      //     pathname: '/bundleDetails',
      //     state: { offers: updatedOffers }
      // });

      (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.webengage) === null || _window5 === void 0 || _window5.track("PdfViewed");
      setBundleLoading(false);
      setShowModal(false);
    })["catch"](function (err) {
      setBundleLoading(false);
      toast.error("Something Went Wrong");
    });
  };
  console.log("Bundle deatils", dealDetails);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "text-[#15509E] sticky top-0 p-4 bg-white z-100 ".concat(showModal ? "md:w-[70%]" : "w-full"),
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return history.goBack();
          },
          className: " h-5 w-5 cursor-pointer "
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between mt-1",
        children: [/*#__PURE__*/_jsxs("div", {
          onClick: onClick,
          className: "hidden md:flex items-center cursor-pointer",
          children: [/*#__PURE__*/_jsx(AiOutlinePrinter, {}), /*#__PURE__*/_jsx("p", {
            className: "ml-2",
            children: "Print"
          })]
        }), /*#__PURE__*/_jsx("p", {
          children: "Remember to take a screenshot"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "p-4 ".concat(internalWebview ? "mb-2" : "", " ").concat(showModal ? "md:w-[70%]" : "w-full"),
      children: [/*#__PURE__*/_jsx("h1", {
        className: "text-center md:text-left font-semibold text-lg md:text-3xl mb-4 mt-5",
        children: "Congratulations on your gifts!"
      }), dealDetails.map(function (offer, i) {
        var _config$deals, _config$deals2, _config$deals3, _config$deals4;
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col md:flex-row gap-x-2 gap-y-4 mt-4 p-4 border-b-2 border-dashed border-gray-300 ".concat(internalWebview ? "mb-3" : ""),
            children: [offer.QRCode && /*#__PURE__*/_jsx("img", {
              className: " md:hidden h-40 rounded self-center",
              src: offer.QRCode
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex",
              children: [/*#__PURE__*/_jsx("img", {
                className: "h-[100px] w-[100px] md:h-[150px] lg:h-[250px] xl:h-[300px] md:w-full rounded-lg",
                src: offer === null || offer === void 0 ? void 0 : offer.thumbnailImageUrl
              }), /*#__PURE__*/_jsx("h1", {
                className: "text-lg font-semibold leading-6 pl-2 md:hidden",
                children: offer.title
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "md:pl-4 w-full md:w-[70%] lg:w-[75%] 2xl:w-[55%]",
              children: [/*#__PURE__*/_jsx("h1", {
                className: "text-2xl font-semibold hidden md:block",
                children: offer.title
              }), /*#__PURE__*/_jsx(DealValidity, {
                date: offer === null || offer === void 0 ? void 0 : offer.endDate,
                removeTopMargin: false
              }), (offer === null || offer === void 0 ? void 0 : offer.description) && isHTML(offer === null || offer === void 0 ? void 0 : offer.description) && /*#__PURE__*/_jsx("div", {
                style: {
                  whiteSpace: "pre-line"
                },
                className: "\n                                ".concat(config !== null && config !== void 0 && (_config$deals = config.deals) !== null && _config$deals !== void 0 && (_config$deals = _config$deals.dealsSection) !== null && _config$deals !== void 0 && _config$deals.subAdditionalTextClass ? config === null || config === void 0 || (_config$deals2 = config.deals) === null || _config$deals2 === void 0 || (_config$deals2 = _config$deals2.dealsSection) === null || _config$deals2 === void 0 ? void 0 : _config$deals2.subAdditionalTextClass : "", " z-10 mt-2 text-sm"),
                dangerouslySetInnerHTML: {
                  __html: offer === null || offer === void 0 ? void 0 : offer.description
                }
              }), (offer === null || offer === void 0 ? void 0 : offer.description) && !isHTML(offer === null || offer === void 0 ? void 0 : offer.description) && /*#__PURE__*/_jsx("div", {
                style: {
                  whiteSpace: "pre-line"
                },
                className: "\n                                ".concat(config !== null && config !== void 0 && (_config$deals3 = config.deals) !== null && _config$deals3 !== void 0 && (_config$deals3 = _config$deals3.dealsSection) !== null && _config$deals3 !== void 0 && _config$deals3.subAdditionalTextClass ? config === null || config === void 0 || (_config$deals4 = config.deals) === null || _config$deals4 === void 0 || (_config$deals4 = _config$deals4.dealsSection) === null || _config$deals4 === void 0 ? void 0 : _config$deals4.subAdditionalTextClass : "", " z-10 mt-2 text-sm "),
                children: LinkParagraph(offer === null || offer === void 0 ? void 0 : offer.description)
              }), offer.redemptionType === "CODE" && /*#__PURE__*/_jsx("div", {
                className: "z-10 flex flex-col md:flex-row mt-4 w-full",
                children: /*#__PURE__*/_jsx("div", {
                  className: "flex items-center",
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "flex",
                    children: [!copiedText && /*#__PURE__*/_jsx("p", {
                      className: "".concat(config !== null && config !== void 0 && config.deals.dealLayout.couponClassName ? config === null || config === void 0 ? void 0 : config.deals.dealLayout.couponClassName : "", " z-10 border-2 font-semibold border-gray-500 border-dashed py-1 px-3 md:px-7 ").concat(config !== null && config !== void 0 && config.darktheme ? "hover:border-[#68BBE3]" : "hover:border-blue-900", "  cursor-pointer my-auto mr-2 md:mr-5 rounded"),
                      title: "Click to copy ",
                      onClick: function onClick() {
                        return handleCopyCode(offer);
                      },
                      children: "Code: " + (offer === null || offer === void 0 ? void 0 : offer.dealRedemptionCode)
                    }), copiedText && /*#__PURE__*/_jsx("p", {
                      className: "z-10 self-center font-normal animate-pulse ".concat(config !== null && config !== void 0 && config.darktheme ? "bg-[#68BBE3B3]  text-white" : "bg-[#154F9D1A] text-[#006EB7]", "   py-2 px-12 text-sm rounded "),
                      children: "Code Copied"
                    })]
                  })
                })
              }), offer.redemptionType === "VOUCHER" && offer.VoucherCode && /*#__PURE__*/_jsx("div", {
                className: "z-10 flex flex-col md:flex-row mt-4 w-full",
                children: /*#__PURE__*/_jsx("div", {
                  className: "flex items-center",
                  children: /*#__PURE__*/_jsx("div", {
                    className: "flex",
                    children: /*#__PURE__*/_jsx("p", {
                      className: "".concat(config !== null && config !== void 0 && config.deals.dealLayout.couponClassName ? config === null || config === void 0 ? void 0 : config.deals.dealLayout.couponClassName : "", " z-10 border-2 font-semibold border-gray-500 border-dashed py-1 px-3 md:px-7 ").concat(config !== null && config !== void 0 && config.darktheme ? "hover:border-[#68BBE3]" : "hover:border-blue-900", "  cursor-pointer my-auto mr-2 md:mr-5 rounded"),
                      title: "Click to copy "
                      // onClick={() =>
                      //     copyCodeHandler(
                      //         offer
                      //     )
                      // }
                      ,
                      children: "Voucher Code: " + (offer === null || offer === void 0 ? void 0 : offer.VoucherCode)
                    })
                  })
                })
              })]
            }), offer.QRCode && /*#__PURE__*/_jsx("img", {
              className: "hidden md:block h-40 rounded self-center md:ml-auto",
              src: offer.QRCode
            })]
          })
        });
      })]
    }), /*#__PURE__*/_jsx(SideModal, {
      visible: showModal,
      onClick: function onClick() {
        setShowModal(false);
        setShowTnc(false);
      },
      className: "w-full top-[40%] md:top-0 lg:w-[30%] md:w-[35%]",
      config: config,
      children: /*#__PURE__*/_jsxs("div", {
        className: "h-full flex flex-col pl-3.5 pt-6 pr-3.5",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex justify-end mr-1 mt-1",
          children: /*#__PURE__*/_jsx(GrClose, {
            onClick: function onClick() {
              setShowModal(false);
              setShowTnc(false);
            },
            className: " h-5 w-5 cursor-pointer "
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "flex mt-1",
          children: /*#__PURE__*/_jsx("h1", {
            className: "font-bold text-base",
            children: "Don't miss these deals to complete your bundle!"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "overflow-y-auto scrollbar-thin",
          children: /*#__PURE__*/_jsx("div", {
            className: "flex flex-col  pt-6 h-[250px] md:h-[80%] space-y-4",
            children: otherBundleDeals.map(function (offer, index) {
              return /*#__PURE__*/_jsxs("div", {
                onClick: function onClick() {
                  return handleCheckboxChange(offer);
                },
                className: "flex items-center gap-4 p-2 hover:bg-gray-100 rounded-md cursor-pointer border-b border-gray-200",
                children: [/*#__PURE__*/_jsx("input", {
                  type: "checkbox",
                  className: "h-4 w-4 cursor-pointer",
                  checked: selectedOffers === null || selectedOffers === void 0 ? void 0 : selectedOffers.some(function (item) {
                    return (item === null || item === void 0 ? void 0 : item.id) === offer.id;
                  })
                }), /*#__PURE__*/_jsx("img", {
                  src: offer.vendorLogoUrl,
                  alt: offer.title,
                  className: "h-20 w-20 object-contain"
                }), /*#__PURE__*/_jsx("span", {
                  className: "text-sm font-medium",
                  children: offer.title
                })]
              }, offer.id);
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "sticky bottom-0 left-0  right-0 w-full z-50 bg-white p-1",
          children: /*#__PURE__*/_jsx("button", {
            onClick: handleRedeemDeal,
            className: "bg-primary text-white w-full py-3 rounded-xl text-base font-semibold",
            children: "Redeem Selected Deal"
          })
        }), showTnc && /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col justify-center absolute inset-0 bg-white bg-opacity-70 backdrop-blur-sm items-center z-50",
          children: [captureUserMobile && /*#__PURE__*/_jsx(PhoneNumber, {
            redeemNowClickedHandler: function redeemNowClickedHandler(mobile) {
              handleRedeemDeal(mobile);
            },
            setCaptureUserMobile: setCaptureUserMobile,
            redux: redux,
            winnreAuth: winnreAuth
          }), !captureUserMobile && /*#__PURE__*/_jsxs("div", {
            className: "pb-4 px-4 flex flex-col -mt-32 md:-mt-0",
            children: [/*#__PURE__*/_jsxs("p", {
              className: "font-semibold",
              children: ["By clicking on ", /*#__PURE__*/_jsx("strong", {
                children: "Redeem selected deal"
              }), ", you agree & authorize Reloy and all partner brands part of this bundle deal to call you or contact you via various communication modes to assist you with your queries. This consent will override your DNC/NDNC registration if any."]
            }), /*#__PURE__*/_jsx("div", {
              className: "flex justify-end mt-4 ",
              children: /*#__PURE__*/_jsx("button", {
                onClick: redeemSelectedBundleOffers,
                className: "bg-gray-400 text-[#3e669b] py-2 px-7 rounded",
                children: bundleLoading && showModal ? "Loading..." : "Agree"
              })
            })]
          })]
        })]
      })
    })]
  });
}
export default BundleDetails;